export enum InsuranceTypes {
    UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS',
    UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE',
    REMOVE_UPLOADED_FILE = 'REMOVE_UPLOADED_FILE'
}
